var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TempCodeProvisionHistoryJournal',{attrs:{"client-id":_vm.$route.params.id,"include-doorphone-address":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }